import { UpDown } from '../icons.js';
import { useMenu } from '../menu.js';
import { periodNeedsDates, periodSubtitle, periodTitle } from '../sprint/labels.js';

import { SprintMenu } from './SprintMenu.js';

import type { SprintKey, Task } from '@nedelnik/shared';

/**
 * Выбор спринта в карточке (3.5, строка «Спринт»).
 *
 * Здесь по очереди стояли степпер со стрелками и родной `select`. Степпер
 * предлагал прошлые недели и дублировал слово «Входящие»; `select` это
 * вылечил, но выглядел чужим среди полей карточки — их рисуем мы, а его
 * браузер.
 *
 * Теперь это обычное поле, которое раскрывается общим меню спринта
 * (`SprintMenu`, 3.5.6). Поле отвечает только за одно: где задача сейчас.
 */
export function SprintPicker({
  task,
  current,
  onPick,
}: {
  task: Task;
  current: SprintKey;
  onPick: (sprint: SprintKey | null) => void;
}): React.ReactElement {
  const menu = useMenu();

  // У недели рядом с номером нужны числа — «н36» сам по себе не говорит
  // ничего. У месяца они лишние: «сентябрь · 1–30 сентября» повторяет одно и
  // то же дважды.
  const label =
    task.sprint === null
      ? 'Входящие · без спринта'
      : periodNeedsDates(task.sprint)
        ? `${periodTitle(task.sprint)} · ${periodSubtitle(task.sprint)}`
        : periodTitle(task.sprint);

  return (
    <span className="menu menu--wide" ref={menu.box}>
      <button
        type="button"
        className="sprintpick"
        aria-haspopup="menu"
        aria-expanded={menu.open}
        onClick={menu.toggle}
      >
        {label}
        {/* Стрелки вверх-вниз — те же, что рисует браузер у своего списка:
            без них поле не отличить от обычного, и нажать в него не приходит
            в голову. */}
        <UpDown />
      </button>

      {menu.open && (
        <SprintMenu
          task={task}
          current={current}
          label="Спринт задачи"
          onPick={(sprint) => {
            onPick(sprint);
            menu.close();
          }}
        />
      )}
    </span>
  );
}
